import {
  Component,
  ElementRef,
  Injector,
  OnChanges,
  OnDestroy,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { PomodoroRepository } from './Models/PomodoroRepository';
import { PushNotificationsService } from 'ng-push-ivy';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from './services/user.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MobileIntroComponent } from './dialogs/mobile-intro/mobile-intro.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { IosPwaIntroComponent } from './pwa-intro/ios-pwa-intro/ios-pwa-intro.component';
import { AndroidPwaIntroComponent } from './pwa-intro/android-pwa-intro/android-pwa-intro.component';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConnectionService } from './services/connection.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from '@angular/animations';
import { GoftinoService } from './services/giftino.sevice';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('animation', [
      transition(':enter', [
        style({ right: '-100px' }), // initial
        animate('0.5s ease-in-out', style({ right: '0%' })), // final
      ]),
      transition(':leave', [
        style({ right: '0%', opacity: 1 }), // initial
        animate('0.5s ease-in-out', style({ right: '-100px', opacity: 0 })), // final
      ]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('toggleButton') toggleButton: ElementRef;
  @ViewChild('toggleText') toggleText: ElementRef;
  @ViewChild('toggleMom') toggleMom: ElementRef;
  @ViewChild('menu') menu: ElementRef;
  public showMobile = false;
  public userIsLoggedIn;
  public login = 'ورود';
  public profile = 'پروفایل';
  public clickToggle = false;
  public pomodoroRepository;
  public loginTitle = 'ورود';
  public innerWidth = window.innerWidth;
  public installPrompt = null;
  public deferredPrompt: any;
  public showButton = true;
  public iosShown = 'no';
  public androidShown = 'no';
  public requestPermissionShown = 'no';
  public networkStatus = false;
  public snackBarRef: any;
  public appIsConnected = 'connected';
  public appOldValue = 'connected';
  public showNotificationAlert = false;
  public networkStatus$: Subscription = Subscription.EMPTY;
  public stateName = ':enter';

  constructor(
    public injector: Injector,
    private ngNotification: PushNotificationsService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    private userService: UserService,
    private router: Router,
    public dialog: MatDialog,
    private bottomSheet: MatBottomSheet,
    private snackBar: MatSnackBar,
    private connectionService: ConnectionService,
    private goftinoService: GoftinoService
  ) {
    this.pomodoroRepository = PomodoroRepository.getInstance(injector);
    this.ngNotification.requestPermission();
    this.renderer.listen('window', 'click', (e: Event) => {
      // tslint:disable-next-line:max-line-length
      if (
        e.target !== this.toggleButton.nativeElement &&
        e.target !== this.toggleText.nativeElement &&
        e.target !== this.toggleMom.nativeElement &&
        e.target !== this.menu.nativeElement
      ) {
        this.pomodoroRepository.isMenuOpen = true;
      }
    });
  }

  ngOnInit(): void {
    localStorage.setItem('connection', this.appIsConnected);
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.userIsLoggedIn = true;
      this.login = 'خروج';
      this.userService.getCurrentUserInfo().subscribe((response) => {
        const userName = localStorage.getItem('username');
        this.goftinoService.setGoftinoUser(
          response.email,
          userName || response.name,
          response.mobile
        );
        localStorage.setItem('isPremium', response.is_premium);
        localStorage.setItem('premiumUntil', response.premium_until);
      });
    } else {
      this.userIsLoggedIn = false;
      this.login = 'ورود';
    }
    this.pomodoroRepository.getTokenDoneTime();
    this.pwaIntro();
    if (
      localStorage.getItem('requestPermissionFront') === null ||
      localStorage.getItem('requestPermissionFront') === 'no'
    ) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        this.showNotificationAlert = false;
      } else {
        setTimeout(() => {
          if (Notification.permission === 'granted') {
            this.showNotificationAlert = false;
          } else if (Notification.permission === 'denied') {
            this.showNotificationAlert = false;
          } else {
            this.showNotificationAlert = true;
          }
        }, 1000);
      }
    }
    // setInterval(() => {
    //   this.connectionService.connection().subscribe(
    //     (res) => {
    //     },
    //     (er) => {
    //       this.appOldValue = this.appIsConnected;
    //       if (er.status === 200) {
    //         this.appIsConnected = 'connected';
    //         if (this.appOldValue !== this.appIsConnected) {
    //           this.pomodoroRepository.save();
    //         }
    //         localStorage.setItem('connection', this.appIsConnected);
    //       }
    //       if (er.status === 0) {
    //         console.log(er);
    //         console.log(er.status);
    //         this.appIsConnected = 'notConnected';
    //         localStorage.setItem('connection', this.appIsConnected);
    //       }
    //     }
    //   );
    // }, 1000);
  }

  openSnackBar(mensaje: string, accion: string): any {
    this.snackBarRef = this.snackBar.open(mensaje, accion, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'left',
      panelClass: ['red-snackbar'],
    });
  }

  // ngDoCheck(): any {
  //   if (this.appOldValue !== this.appIsConnected) {
  //     // run sync task
  //     this.pomodoroRepository.save();
  //     // console.log('Last Session Was Conflict: ' + this.appIsConnected);
  //   }
  // }

  ngOnDestroy(): void {
    this.networkStatus$.unsubscribe();
  }

  // tslint:disable-next-line:typedef
  async logOut() {
    this.pomodoroRepository.prevLang = localStorage.getItem('trans');
    await localStorage.clear();
    localStorage.setItem('trans', this.pomodoroRepository.prevLang);
    this.pomodoroRepository.userIsLoggedIn = false;
    this.userIsLoggedIn = false;
    this.userService.logOut();
    location.reload();
    this.router.navigateByUrl('/').then();
  }

  changeBtnTitle(): any {
    const token = localStorage.getItem('token');
    if (token !== null) {
      this.loginTitle = 'ورود';
    } else {
      this.loginTitle = 'خروج';
    }
  }

  openMenu(): any {
    this.pomodoroRepository.showMobile = true;
  }

  closeMenu(): any {
    this.pomodoroRepository.showMobile = false;
  }

  toggleMenu(): any {
    this.pomodoroRepository.isMenuOpen = !this.pomodoroRepository.isMenuOpen;
  }

  askForTour(): any {
    // this.dialog.open()
  }

  askForIntroInMobile(): any {
    this.dialog.open(MobileIntroComponent);
  }

  pwaIntro(): any {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      if (/Android/i.test(navigator.userAgent)) {
        if (
          localStorage.getItem('androidIntro') === null ||
          localStorage.getItem('androidIntro') === 'no'
        ) {
          this.openAndroidIntro();
        } else {
          return;
        }
      }
      if (/iPhone/i.test(navigator.userAgent)) {
        if (
          localStorage.getItem('iosIntro') === null ||
          localStorage.getItem('iosIntro') === 'no'
        ) {
          this.openIosIntro();
        } else {
          return;
        }
      }
    } else {
      return;
    }
  }

  openIosIntro(): void {
    this.bottomSheet.open(IosPwaIntroComponent);
  }

  openAndroidIntro(): void {
    this.bottomSheet.open(AndroidPwaIntroComponent);
  }

  sendRequestPermission(): any {
    Notification.requestPermission().then();
    this.requestPermissionShown = 'yes';
    localStorage.setItem('requestPermissionFront', this.requestPermissionShown);
    this.showNotificationAlert = false;
  }
  dismissRequestPermission(): any {
    this.requestPermissionShown = 'yes';
    localStorage.setItem('requestPermissionFront', this.requestPermissionShown);
    this.showNotificationAlert = false;
  }
}
